$(function(){

    $('.has-dropdown').mouseenter(function() {
        var megaMenuID = $('a', this).data('mega');

        $(this).addClass('menu-open');
        $('.mega-menu').slideUp();
        $('[data-menu="'+ megaMenuID +'"]').stop().slideDown();
        // $('[data-menu="'+ megaMenuID +'"]').toggleClass('open');


    }).mouseleave(function() {
        if ($('.mega-menu:hover').length != 0) {
            $('.mega-menu').mouseenter(function () {

                $(this).css('display', 'block');

            }).mouseleave(function () {
                $(this).stop().slideUp()
            })
        }else{
            $('.mega-menu').stop().slideUp()
        }

    });


    $('.js-mega-menu-open').click(function(){
        $('.mega-menu-mobile').addClass('mega-menu-mobile--open');
        $('body').css('overflow-y', 'hidden');
    })

    $('.js-close-mega-menu-close').click(function(){
        $('.mega-menu-mobile').removeClass('mega-menu-mobile--open');
        $('body').css('overflow-y', 'inherit');

    });
    var firstClick = true;
    $('.mega-menu-mobile .menu-item-has-children').on('click', function(e){
        if(firstClick == true){
            e.preventDefault();
            firstClick = false;
        }
        $('.sub-menu', this).css('display', 'flex');
    })

})